export const QUANTITY_MAX = 999_999_999;
export const DIMENSION_MAX = 999.99;
export const UOM_SKU_MAX_LENGTH = 200;
// Sentinel for "no Contains selection". Must not collide with any real productUnitOfMeasureId —
// the Each base unit is id 0, so use -1 to keep Each a valid, selectable Contains value.
export const CONTAINS_ID_UNSET = -1;
